<div [ngClass]="{ embedded: hideHeader$ | async }" [class.bookme--initializing]="initializing">
  @if (!initializing && (hideHeader$ | async) !== true && !isMeetingInfoRoute &&
  !isRescheduleConfirmationRoute && (shouldDisplayError$ | async) !== true) {
  <div
    id="calendar-header"
    class="header"
    [ngClass]="{ 'landing-header': !calendar }"
  >
    @if (calendar || groupOrServiceLogoUrl) {
    <img
      [src]="calendar?.displayLogoUrl || groupOrServiceLogoUrl"
      class="logo"
      alt=""
      (load)="onImageLoaded($event)"
    />
    }
  </div>
  } @if (isMeetingInfoRoute || isRescheduleConfirmationRoute) {
  <div class="header-spacer"></div>
  } @if (shouldDisplayError$ | async) {
  <div class="error-spacer"></div>
  @switch (errorDisplay$ | async) { @case ('conflict-booking') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@BOOK.TIME_SLOT_UNAVAILABLE">Time slot unavailable</h2>
      <p i18n="@@BOOK.TIME_SLOT_UNAVAILABLE_DESCRIPTION">
        The time slot you selected is no longer available. Please choose a new
        time to continue.
      </p>
      <button
        mat-flat-button
        color="primary"
        (click)="gotoCalendar()"
        i18n="@@BOOK.SELECT_NEW_TIME"
      >
        Select new time
      </button>
    </div>
  </div>
  } @case ('error-host') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@BOOK.HOST_NOT_FOUND">Host not found</h2>
      <p i18n="@@BOOK.UNABLE_TO_DETERMINE_HOST">
        We cannot determine who the host of the meeting is supposed to be.
        Please try again.
      </p>
    </div>
  </div>
  } @case ('error-404') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@BOOK.EVENT_TYPE_NOT_FOUND">Booking page not found</h2>
      <p i18n="@@BOOK.MEETING_TYPE_NOT_FOUND">
        Something went wrong while setting up the meeting. Please contact your
        Host.
      </p>
    </div>
  </div>
  } @case ('slug-mismatch-error') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@BOOK.SOMETHING_WENT_WRONG">Sorry, something went wrong!</h2>
      <p i18n="@@GROUP_SERVICE.ERROR">
        There seems to be an issue with the URL. Please contact the
        administrator for assistance.
      </p>
    </div>
  </div>
  } @case ('error-lookup') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@BOOK.SOMETHING_WENT_WRONG">Sorry, something went wrong!</h2>
      <p i18n="@@BOOK.PROBLEM_LOADING_MEETING">
        There was a problem loading the requested meeting.
      </p>
    </div>
  </div>
  } @case ('meeting-already-cancelled') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@MEETING.ALREADY_CANCELLED">Meeting already cancelled</h2>
      <p i18n="@@MEETING.ALREADY_CANCELLED_DESCRIPTION">
        This meeting has already been cancelled.
      </p>
    </div>
  </div>
  } @case ('meeting-not-found') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@MEETING.NOT_FOUND">Meeting not found</h2>
      <p i18n="@@MEETING.NOT_FOUND_DESCRIPTION">
        The meeting you're looking for could not be found. Please check the URL or
        contact the host.
      </p>
    </div>
  </div>
  } @case ('meeting-error') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@MEETING.ERROR">Something went wrong</h2>
      <p i18n="@@MEETING.ERROR_DESCRIPTION">
        There was an error with this meeting. Please try again later or contact
        support.
      </p>
    </div>
  </div>
  } @case ('meeting-cancelled-cannot-reschedule') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@MEETING.CANCELLED_CANNOT_RESCHEDULE">
        Meeting has been cancelled
      </h2>
      <p i18n="@@MEETING.CANCELLED_CANNOT_RESCHEDULE_DESCRIPTION">
        This meeting has been cancelled and can no longer be rescheduled.
      </p>
    </div>
  </div>
  } @case ('meeting-reschedule-not-found') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@MEETING.RESCHEDULE_NOT_FOUND">Meeting not found</h2>
      <p i18n="@@MEETING.RESCHEDULE_NOT_FOUND_DESCRIPTION">
        The meeting you're trying to reschedule could not be found. Please check
        the URL or contact the host.
      </p>
    </div>
  </div>
  } @case ('meeting-reschedule-error') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@MEETING.RESCHEDULE_ERROR">Rescheduling failed</h2>
      <p i18n="@@MEETING.RESCHEDULE_ERROR_DESCRIPTION">
        There was an error rescheduling this meeting. Please try again later or
        contact support.
      </p>
    </div>
  </div>
  } @case ('meeting-type-deleted') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@BOOK.EVENT_TYPE_IS_DELETED">
        Booking page is no longer available
      </h2>
      <p i18n="@@BOOK.MEETING_TYPE_NO_LONGER_EXISTS">
        This meeting link is no longer available. Please contact your Host.
      </p>
    </div>
  </div>
  } @case ('meeting-host-not-connected') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@BOOK.HOST_NOT_AVAILABLE">Selected host/calendar not connected</h2>
      <p i18n="@@BOOK.HOST_NOT_AVAILABLE_ERROR_MESSAGE">
        We ran into an unexpected issue while scheduling your meeting/appointment
        and it has not been scheduled. Your host has been notified.
      </p>
    </div>
  </div>
  } @case ('meeting-type-expired') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@BOOK.EVENT_TYPE_IS_EXPIRED">
        There are no available date/time slots
      </h2>
      <p i18n="@@BOOK.MEETING_TYPE_EXPIRED">Please get in touch with host</p>
    </div>
  </div>
  } @case ('error-meeting-type') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@BOOK.EVENT_TYPE_ERROR">Issue loading booking page</h2>
      <p i18n="@@BOOK.EVENT_TYPE_ERROR_DESCRIPTION">
        Something went wrong while setting up the meeting. Please contact your
        Host.
      </p>
    </div>
  </div>
  } @case ('shared-video-not-found') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@SHARED_VIDEO.NOT_FOUND">Video not found</h2>
      <p i18n="@@SHARED_VIDEO.NOT_FOUND_DESCRIPTION">
        This video doesn't exist or is no longer available.
      </p>
    </div>
  </div>
  } @case ('shared-video-error') {
  <div class="container">
    <div class="alert">
      <div class="alert__icon-wrapper"><mat-icon class="big-icon caution">warning_amber</mat-icon></div>
      <h2 i18n="@@SHARED_VIDEO.ERROR">Something went wrong</h2>
      <p i18n="@@SHARED_VIDEO.ERROR_DESCRIPTION">
        Unable to load the video. Please try again later.
      </p>
    </div>
  </div>
  } @case ('no-host') {
  <app-bookme-landing-page></app-bookme-landing-page>
  } } } @else if (!initializing) {
  <div [@animTrigger]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
  }
</div>
